import RowButton from 'components/atoms/row-button'
import React from 'react'
import PropTypes from 'prop-types'
import CmsMerchantBioService from 'domains/cms-merchant/services/bio-service'
import { WEB_URL_CONSTANTS } from 'constants/web-url-constants'


const propTypes = {
  buttonText    : PropTypes.string,
  buttonColour  : PropTypes.string,
  onButtonClick : PropTypes.func
}

const actionCellPropTypes = {
  cell: PropTypes.shape({
    row: PropTypes.shape({
      original: PropTypes.object
    })
  })
}

/**
 * Columns definition for Cms Merchant Table
 * @param {string} buttonText - The text that appears at the button on each row
 * @param {string} buttonColour - Bootstrap button type class name (eg. primary)
 * @param {Function} onButtonClick - function that will run when the button is clicked
 */
const CmsMerchantTableColumns = ({
  buttonText,
  buttonColour,
  onButtonClick
}) => {

  const BioCell    = (row) => CmsMerchantBioService.format(row.cell.value)
  const UrlKeyCell = (row) => (
    <a
      className='text-primary'
      href={ `${WEB_URL_CONSTANTS.HOMEPAGE}/merchants/${row.cell.value}` }
      target='_blank' rel='noopener noreferrer'
    >
      { `merchants/${row.cell.value}` }
    </a>
  )

  const ActionCell = ({ cell: { row } }) => (
    <RowButton
      data={ row.original }
      color={ buttonColour }
      onClick={ onButtonClick }
      text={ buttonText }
    />
  )

  ActionCell.propTypes = actionCellPropTypes

  return (
    [
      {
        Header  : 'Merchant',
        columns : [
          {
            Header         : 'ID',
            accessor       : 'merchant.id',
            disableFilters : true
          },
          {
            Header   : 'Name',
            accessor : 'merchant.name',
            id       : 'merchant_name'
          },
          {
            Header   : 'Url Key',
            accessor : 'merchant.url_key',
            id       : 'merchant_url_key',
            Cell     : UrlKeyCell
          }
        ]
      },
      {
        Header         : 'Bio',
        accessor       : 'bio',
        disableFilters : true,
        Cell           : BioCell
      },

      {
        Header : 'Action',
        id     : 'action',
        Cell   : ActionCell
      }
    ]
  )
}

CmsMerchantTableColumns.propTypes = propTypes

export default CmsMerchantTableColumns
